'use client'

import Link from 'next/link'
import type { ReactNode } from 'react'
import { captureProductEvent, PRODUCT_EVENTS } from '@/lib/product-analytics'
import type { CrossSellPlacement, CrossSellTarget } from '@/lib/santa-video/video-moments'

/**
 * Un enlace de los cross-sells de los vídeos, medido. Existe como client
 * component solo para el clic: los cross-sells son server components y, sin
 * esto, no se sabría qué tarjeta ni desde dónde lleva a la tienda.
 */
export function CrossSellLink({ href, className, placement, target, children }: {
  href: string
  className: string
  placement: CrossSellPlacement
  target: CrossSellTarget
  children: ReactNode
}) {
  return (
    <Link
      className={className}
      href={href}
      onClick={() => captureProductEvent(PRODUCT_EVENTS.VIDEO_CROSS_SELL_CLICKED, { product: 'video', placement, target })}
    >
      {children}
    </Link>
  )
}
